import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { Modal, ModalHeader } from 'reactstrap'
import { getDOMResults } from './lib/connections'

const ExternalContentModal = ({
  openModal, url, doms, content, onToggleModal
}) => {
  function selectDom() {
    return doms.find(dom => dom.target === url) || {}
  }

  const { data } = useQuery(['content', selectDom().location], async () => {
    const result = await getDOMResults(selectDom().location, content)
    return result
  }, {
    enabled: openModal && !!selectDom().location
  })

  return (
    <Modal isOpen={openModal} toggle={onToggleModal} size="lg" backdrop={false}>
      <ModalHeader toggle={onToggleModal}>
        <p className="mb-0">
          A comparação abaixo foi criada por Reescrever.app. Os parágrafos com destaques
          foram adicionados para mostrar as diferenças com o texto fornecido para
          comparação.

          <small className="d-block">
            <a href={url || '#'} target="_blank" rel="noopener noreferrer">
              {url || ''}
            </a>
          </small>
        </p>
      </ModalHeader>

      {
        data?.dom && (
          <iframe
            title="iframe-for-url-content"
            height="400"
            srcDoc={data.dom || ''}
            style={{ border: "none" }}
            allowFullScreen
          />
        )
      }
    </Modal>
  )
}

export default ExternalContentModal
